import { type Variants } from 'motion/react';
import * as motion from 'motion/react-client';

import LinkButton from '@/decodo/components/atoms/LinkButton';
import { LinkButtonStrapiProps } from '@/decodo/components/atoms/LinkButton/LinkStrapi';

type ExtraLinksProps = {
  links: LinkButtonStrapiProps[];
  onLinkClick?: () => void;
};

export function MobileExtraLinks({ links, onLinkClick }: ExtraLinksProps) {
  return (
    <motion.ul
      className='light headerLg:hidden border-gray-dark-200 grid grid-cols-2 items-center gap-6 border-t px-5 py-6 lg:grid-cols-3'
      variants={listVariants}
    >
      {links
        .toReversed()
        .map((link) =>
          link.text ? (
            <ExtraLinkItem
              key={link.url}
              link={{ ...link, text: link.text! }}
              handleClick={onLinkClick}
            />
          ) : null
        )}
    </motion.ul>
  );
}

function ExtraLinkItem({
  link,
  handleClick,
}: {
  link: LinkButtonStrapiProps & { text: string };
  handleClick?: () => void;
}) {
  if (link.variant === 'outlined') {
    return (
      <motion.li className='col-span-2 lg:col-span-1' variants={itemVariants}>
        <LinkButton
          fullwidth
          href={link.url}
          variant='filled'
          color='primary'
          classNames={{
            inner: 'text-base-dark-white',
          }}
          onClick={handleClick}
        >
          {link.text}
        </LinkButton>
      </motion.li>
    );
  }

  return (
    <motion.li variants={itemVariants}>
      <LinkButton
        fullwidth
        href={link.url}
        variant='outlined'
        color='secondary'
        onClick={handleClick}
      >
        {link.text}
      </LinkButton>
    </motion.li>
  );
}

const listVariants = {
  open: {
    opacity: 1,
    y: 0,
    transition: {
      staggerChildren: 0.03,
      delayChildren: 0.75,
      delay: 0.9,
      duration: 0.2,
    },
  },
  closed: {
    opacity: 0,
    y: 48,
    transition: { staggerChildren: 0.05, staggerDirection: -1 },
  },
} satisfies Variants;

const itemVariants = {
  open: {
    y: 0,
    opacity: 1,
    transition: {
      y: { velocity: -100 },
    },
  },
  closed: {
    y: 24,
    opacity: 0,
  },
} satisfies Variants;
